import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const NavLinks = ({ children }: Props) => (
  <div className={'flex flex-row justify-end gap-4'}>{children}</div>
);

export default NavLinks;
